<template>
  <div v-if="$store.state.showVolumeControls" class="volume-control-page">
    <div class="content">
      <h1>
        <b>[&nbsp;</b>
        <i>THE OPERATOR</i>
        <b>&nbsp;]</b>
      </h1>

      <label for="volumeSlider" class="label">Background audio: {{volume}}%</label>
      <input
        class="slider"
        type="range"
        min="0"
        max="100"
        :value="volume"
        id="volumeSlider"
        @input="setVolume($event)"
      />
    </div>
    <button @click="$store.dispatch('hideVolumeControls')">CLOSE</button>
  </div>
</template>

<script>
import { Howler } from "howler";

export default {
  data: function() {
    return { volume: Howler.volume() * 100 };
  },

  methods: {
    setVolume(event) {
      this.volume = event.target.value;
      Howler.volume(event.target.value * 0.01);
    }
  }
};
</script>

<style lang="scss">
@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.volume-control-page {
  width: 768px;
  height: 768px;
  padding: 120px;
  background-color: #000000;
  background-image: url("../assets/images/grid-white-x2.png");
  color: #f1ece6;

  .label {
    margin-top: 30px;
    display: block;
  }

  .slider {
    -webkit-appearance: none; /* Override default CSS styles */
    appearance: none;
    width: 50%; /* Full-width */
    height: 2px; /* Specified height */
    background: #b1b1b1; /* Grey background */
    outline: none; /* Remove outline */
    margin-top: 20px;
  }

  /* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
  .slider::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #ffffff;
    border: 1px solid #b1b1b1;
    cursor: pointer; /* Cursor on hover */
  }

  .slider::-moz-range-thumb {
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: #ffffff;
    border: 1px solid #b1b1b1;
    cursor: pointer; /* Cursor on hover */
  }

  button {
    position: absolute;
    bottom: 117px;
    right: 117px;
    width: 60px;
    height: 30px;
    // padding: 10px;
    cursor: pointer;
    font-size: 13px;
    line-height: 32px;
    background-color: #f1ece6;
    color: black;
    border: none;
    outline: none;
    animation: flickerAnimation 3s infinite;
  }
}
</style>
